"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookmarkFlags = void 0;
exports.withBookmarkExpanded = withBookmarkExpanded;
/** Флаги закладки (wire `Flg`, как `AbstractC0173v.a.f1634d`). */
exports.BookmarkFlags = {
    FOLDER: 1,
    EXPANDED: 16,
};
function withBookmarkExpanded(item, expanded) {
    const flags = expanded
        ? (item.flags | exports.BookmarkFlags.EXPANDED)
        : (item.flags & ~exports.BookmarkFlags.EXPANDED);
    return {
        ...item,
        flags,
        isExpanded: expanded,
    };
}
